rebru.elements = function() {

    var init = function (config) {

        /** Definitions */
        /* Selectpicker */
        var selectpickerDefaultOptions = { showIcon: true };
        var selectpickerOptions = selectpickerDefaultOptions;
        var maxlengthDefaultOptions = { placement: 'top' };
        var maxlengthOptions = maxlengthDefaultOptions;

        if(config) {

            if("elements" in config) {
                /** Selectpicker **/
                if("selectpicker" in config.elements) {
                    selectpickerOptions = $.extend(selectpickerDefaultOptions, config.elements.selectpicker );
                }

                /** Maxlength */
                if("maxlength" in config.elements) {
                    maxlengthOptions = $.extend(maxlengthDefaultOptions, config.elements.maxlength);
                }

            }

        }
        $('.bs-select').selectpicker(selectpickerOptions);

        /* Maxlength */
        $('input[maxlength]').maxlength(maxlengthOptions);

        /* Tooltips */
        $('[data-toggle="tooltip"]').tooltip('dispose');
        setTimeout(function() {
            $('[data-toggle="tooltip"]').tooltip();
        }, 100);

        $('.datetimepicker, .datepicker').each(function() {
            if($(this).data('datepicker')) {
                $(this).data('datepicker').destroy();
            }
        });

        $('.datetimepicker').on('click', function() {
            $(this).datetimepicker({
                autoclose: true,
                todayhighlight: true,
                format: "dd.mm.yyyy hh:ii",
                orientation: "bottom left",
                language: 'de'
            }).blur().focus();
        });

        $('.datepicker').on('click', function() {
            $(this).datetimepicker({
                autoclose: true,
                todayHighlight: true,
                orientation: "bottom left",
                format: "dd.mm.yyyy",
                minView: 2,
                maxView: 4,
                language: 'de'
            }).blur().focus();
        });
    };

    return {
        init: function(config) {
            init(config);
        }
    };
}();